import React from 'react';
import { useTranslation } from 'react-i18next';

import { UpdateTenantDrawerContent } from '@/backoffice/features/tenants/components/update-tenant/update-tenant-drawer-content';
import { TUpdateTenantProps } from '@/backoffice/features/tenants/components/update-tenant/update-tenant.types';
import { EditIcon } from '@/shared/assets/icons/edit-icon';
import { DrawerController } from '@/shared/components/ui/drawer-controller/drawer-controller';
import { MenuItem } from '@/shared/components/ui/menu-item/menu-item';
import { Can } from '@/shared/features/permissions/components/can/can';

export const UpdateTenant: React.FC<TUpdateTenantProps> = ({
  tenantId,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Can action="backofficeTenant:updateTenant" ids={tenantId}>
      <DrawerController
        trigger={<MenuItem icon={<EditIcon />}>{t('common:edit')}</MenuItem>}
        title={t('backoffice:edit_tenant.title')}
        width="500px"
      >
        {(handleClose, isOpen) =>
          isOpen ? (
            <UpdateTenantDrawerContent
              tenantId={tenantId}
              handleClose={() => {
                onClose?.();
                handleClose();
              }}
            />
          ) : null
        }
      </DrawerController>
    </Can>
  );
};
